import React, { useEffect, useState } from 'react';
import { ECompanyOrAssociationType, UserInfosModel } from '../../models/user/UserInfosModel';
import { fetchMe } from '../../hooks/actions/users';
import PrivateUser from './PrivateUser';
import AssociationOrCompanyUser from './AssociationOrCompanyUser';
import { useAuth } from 'react-oidc-context';
import { useUserContext } from '../../hooks/auth/UserProvider';

const UserInfos: React.FC = () => {
  const [userInfo, setUserInfo] = useState<UserInfosModel | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [error, setError] = useState(false);
  const auth = useAuth();
  const {user} = useUserContext();
  const [CompanyOrAssociationType, setCompanyOrAssociationType] = useState<ECompanyOrAssociationType>();


  useEffect(() => {
    fetchMe().then(resp => {
      setUserInfo(resp);
    }).catch(error =>{
      setErrorMsg(error);
      setError(true);
    });
  }, []);

  useEffect(()=>{
    if (auth.isLoading) return;

    if (!auth.isAuthenticated) {
      auth.signinRedirect({ state: window.location.pathname });
      return;
    }

    if (auth.user && user) {
      
      // Association
      const associationRoles = ["Association"];
      // Company
      const companyRoles = ["Company"];

      const hasRole = (userRoles: string | string[] | undefined | null, rolesToCheck: string[]): boolean => {
          if (Array.isArray(userRoles)) {
              return userRoles.some((role: string) => rolesToCheck.includes(role));
          } else if (typeof userRoles === "string") {
              return rolesToCheck.includes(userRoles);
          }
          return false; // Se userRoles è undefined o null
      };
                          
      // Association
      if (hasRole(user.role, associationRoles)) {
          setCompanyOrAssociationType(ECompanyOrAssociationType.Association)
      }
      
      // Company
      if (hasRole(user.role, companyRoles)) {
          setCompanyOrAssociationType(ECompanyOrAssociationType.Company)
      }

        // fidelity
        //fetchFidelityLevel().finally();
          
    }
        
  },[auth.isLoading, auth.isAuthenticated, auth.user, user])

  if (!userInfo) return <div>Loading...</div>;

  const isPrivateUser = userInfo.isPrivate;

  return (
    <div>
      {isPrivateUser ? (
            <PrivateUser user={userInfo}/>
        ) : (
           <AssociationOrCompanyUser user={userInfo} type={CompanyOrAssociationType} />
        )
      }
    </div>
  );
};

export default UserInfos;
